import React, { useEffect, useState } from "react";
import PrintAccountsDesign from "../General/PrintAccounts";
import { useDispatch, useSelector } from "react-redux";
import { Show_Message } from "../General/Messagedialogbox";
import { API_FETCH, DecryptData } from "../General/Utility";

function AccountsButton(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);

  const _AccParem = useSelector((state) => state.Accounts.default);
  const [isSaveDisable, setisSaveDisable] = useState(false);
  const [isDeleteDisable, setisDeleteDisable] = useState(false);
  const [isSettlementDisable, setisSettlementDisable] = useState(false);
  useEffect(() => {
    ButtonPermission();
  }, [props.iVouchId, props.iScrId, _AccParem.isCancelStatus]);

  const ButtonPermission = async () => {
    const _LocalParems = await DecryptData(localStorage.jbctrlparams);
    let ListMenu = _LocalParems.AccountsPer.filter(
      (Data) => Data.iScrId === props.iScrId
    );
    if (ListMenu.length === 0) {
      // No permission entry found for this screen - keep everything
      // disabled instead of crashing on ListMenu[0].
      setisSaveDisable(true);
      setisDeleteDisable(true);
      setisSettlementDisable(true);
      return;
    }
    if (Number(props.iVouchId) > 0) {
      if (_AccParem.isCancelStatus === false) {
        setisSaveDisable(!ListMenu[0].isModify);
        setisDeleteDisable(!ListMenu[0].isDelete);
        // FIX: Settlement was never re-enabled here, so once a cancelled
        // voucher was viewed once, Settlement stayed disabled for every
        // valid voucher selected afterwards until Clear was clicked.
        setisSettlementDisable(false);
      } else {
        setisSettlementDisable(true);
        setisSaveDisable(true);
        setisDeleteDisable(true);
      }
    } else if (Number(props.iVouchId) === 0) {
      setisSaveDisable(!ListMenu[0].isCreate);
      // FIX: for a brand-new (unselected) entry there is nothing to
      // delete or settle yet - these were previously left at whatever
      // stale value the last selected voucher had.
      setisDeleteDisable(true);
      setisSettlementDisable(true);
    }
  };
  const PrintAccounts = async () => {
    if (Number(props.iVouchId) === 0)
      Show_Message(dispatch, "Please Select Voucher", "info");
    else {
      let VoucherId = Number(props.iVouchId);
      let TempId = 0;
      const res = await API_FETCH(
        `PrintDesing/PrintAccounts/${props.iScrId}/${TempId}/${VoucherId}/${_AuthParems.DB}`,
        dispatch
      );
      if (res) PrintAccountsDesign(res, props.iScrId, "Print");
    }
  };

  return (
    <div className="btn-section">
      <button
        type="button"
        className="btn-fabgreen"
        onClick={props.Save}
        disabled={
          isSaveDisable ? true : _AccParem.iVenTypeId === 6 ? true : false
        }
      >
        Save &nbsp; <i className="fas fa-save"></i>
      </button>
      <button
        type="button"
        className="btn-fabgreen"
        onClick={() => {
          props.Clear();
        }}
      >
        Clear &nbsp; <i className="fas fa-eraser"></i>
      </button>
      {props.iScrId !== 43 && props.iScrId !== 44 && (
        <button
          type="button"
          disabled={
            isSettlementDisable
              ? true
              : _AccParem.iVenTypeId === 6
              ? true
              : false
          }
          className="btn-fabgreen"
          onClick={() => {
            window.location.href =
              props.iScrId === 41
                ? "/Accounts/PaySettlement"
                : "/Accounts/RecSettlement";
          }}
        >
          Settlement &nbsp; <i className="fas fa-sync"></i>
        </button>
      )}
      <button
        type="button"
        className="btn-fabgreen"
        onClick={props.Cancel}
        disabled={
          isDeleteDisable ? true : _AccParem.iVenTypeId === 6 ? true : false
        }
      >
        Cancel &nbsp; <i className="far fa-trash-alt"></i>
      </button>
      <button type="button" className="btn-fabgreen" onClick={PrintAccounts}>
        Print &nbsp; <i className="fa-solid fa-print"></i>
      </button>
      <button
        type="button"
        className="btn-fabgreen"
        onClick={() => (window.location.href = `/JustBill/DashBoard`)}
      >
        Close &nbsp; <i className="fas fa-times"></i>
      </button>
    </div>
  );
}
export default AccountsButton;